import Axios from "axios";
import {
    SET_ASSET_PREPARATION_LIST,
    UNSET_ASSET_PREPARATION_LIST,
    SET_ASSET_REGISTER_PREPARATION_LIST,
    UNSET_ASSET_REGISTER_PREPARATION_LIST,
    SET_EDITING_ASSET_PREPARATION,
    UNSET_EDITING_ASSET_PREPARATION,
} from "@/store/mutation-types";

import { saveUpdateAssetPreparation, getAssetPreparationList, getAssetRegisterPreparationsList, getAssetPreparationById } from "@/store/api";

const state = {
    getAssetPreparationList: [],
    getAssetRegisterPreparationsList:[],
    getEditingAssetPreparation: null,
};

const getters = {
    getAssetPreparationList(state) {
        return state.getAssetPreparationList;
    },
    getAssetRegisterPreparationsList(state) {
        return state.getAssetRegisterPreparationsList;
    },
    getEditingAssetPreparation(state) {
        return state.getEditingAssetPreparation;
    }
};

const mutations = {
    [SET_ASSET_PREPARATION_LIST](state, data) {
        state.getAssetPreparationList = data;
    },
    [UNSET_ASSET_PREPARATION_LIST](state) {
        state.getAssetPreparationList = [];
    },
    [SET_ASSET_REGISTER_PREPARATION_LIST](state, data) {
        state.getAssetRegisterPreparationsList = data;
    },
    [UNSET_ASSET_REGISTER_PREPARATION_LIST](state) {
        state.getAssetRegisterPreparationsList = [];
    },
    [SET_EDITING_ASSET_PREPARATION](state, data) {
        state.getEditingAssetPreparation = data;
    },
    [UNSET_EDITING_ASSET_PREPARATION](state) {
        state.getEditingAssetPreparation = null;
    }
};

const actions = {
    saveUpdateAssetPreparation({ commit }, data) {
        commit("SET_LOADING", {color: "primary"});
        return new Promise((resolve, reject) => {
            Axios.post(saveUpdateAssetPreparation, data)
                .then(function (response) {
                    resolve(response);
                })
                .catch(function (error) {
                    reject(error);
                })
                .then((always) => {
                    commit("UNSET_LOADING");
                });
        });
    },

    getAssetPreparationList({ commit }, data) {
        return new Promise((resolve, reject) => {
            Axios.get(getAssetPreparationList, { params: data})
                .then(function (response) {
                    commit('SET_ASSET_PREPARATION_LIST', response.data.data)
                    resolve(response);
                })
                .catch(function (error) {
                    commit('UNSET_ASSET_PREPARATION_LIST')
                    reject(error);
                })
                .then((always) => {
                });
        });
    },

    getAssetRegisterPreparationsList({ commit }, data) {
        return new Promise((resolve, reject) => {
            Axios.get(getAssetRegisterPreparationsList, { params: data})
                .then(function (response) {
                    commit('SET_ASSET_REGISTER_PREPARATION_LIST', response.data.data)
                    resolve(response);
                })
                .catch(function (error) {
                    commit('UNSET_ASSET_REGISTER_PREPARATION_LIST')
                    reject(error);
                })
                .then((always) => {
                });
        });
    },

    getAssetPreparationById({ commit }, data) {
        const getAssetPreparationRecordById = `${getAssetPreparationById}/${data}`;
            commit("SET_LOADING", { color: "primary" });
            return new Promise((resolve, reject) => {
                Axios.get(getAssetPreparationRecordById)
                .then((response) => {
                    resolve(response.data); 
                })
                .catch((error) => {
                    console.error("API Error:", error.response?.data || error.message);
                    reject(error);
                })
                .finally(() => {
                    commit("UNSET_LOADING");
                });
            }
        );
    },
};

export default {
    state,
    getters,
    actions,
    mutations,
};


